import React from "react";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-content">
                <p className="footer-text">
                    © {currentYear} Burro Verde. All rights reserved.
                </p>

                <img
                    src="/burro-verde-l.png"
                    alt="Burro Verde logo"
                    className="footer-logo"
                />
            </div>
        </footer>
    );
}
